export default ({ string = '', replace = [] } = {}) => {
  let replacedString = string;
  replace.forEach(arr => {
    replacedString = replacedString.replace(arr[0], arr[1]);
  });

  return replacedString;
};
